import { render } from "./AdminTicketWinner.vue?vue&type=template&id=33e6a6f8&scoped=true"
import script from "./AdminTicketWinner.vue?vue&type=script&lang=js"
export * from "./AdminTicketWinner.vue?vue&type=script&lang=js"

import "./AdminTicketWinner.vue?vue&type=style&index=0&id=33e6a6f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33e6a6f8"]])

export default __exports__